import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getCollectionKey, getCollectionsKey } from '../../utils/keys';
export const useDeleteCollection = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation(input => client.collections.delete(input.id), {
        onSettled: (data, error, input) => {
            const collectionKey = getCollectionKey({ variables: input });
            queryClient.removeQueries(collectionKey);
            const collectionsKey = getCollectionsKey();
            queryClient.invalidateQueries(collectionsKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useDeleteCollection.js.map